import React, { FormEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateUserAction } from "../../state/user/actions";
import { State } from "../../state/state";
import styles from "./styles.stylesheet.module.scss";

export const Account = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: State) => state.user.user);

  const [isEditing, setIsEditing] = useState(false);
  const [email, setEmail] = useState(user?.email || "");
  const [firstName, setFirstName] = useState(user?.first_name || "");
  const [lastName, setLastName] = useState(user?.last_name || "");
  const [isSaving, setIsSaving] = useState(false);
  const [statusMessage, setStatusMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!user || isEditing) return;
    setEmail(user.email);
    setFirstName(user.first_name || "");
    setLastName(user.last_name || "");
  }, [user, isEditing]);

  const handleSave = async (event: FormEvent) => {
    event.preventDefault();
    if (!user) return;

    setIsSaving(true);
    setStatusMessage(null);
    await updateUserAction(
      user.id,
      email.trim(),
      firstName.trim(),
      lastName.trim(),
    )(dispatch);
    setIsEditing(false);
    setStatusMessage("Profile updated successfully.");
    setIsSaving(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEmail(user?.email || "");
    setFirstName(user?.first_name || "");
    setLastName(user?.last_name || "");
  };

  return (
    <main className={styles.accountPage}>
      <header className={styles.accountHeader}>
        <div>
          <h1>Account</h1>
        </div>
      </header>

      <form className={styles.accountCard} onSubmit={handleSave}>
        <div className={styles.accountCardHeader}>
          <div>
            <h2>User Details</h2>
            <p>Manage your email, name, and profile details.</p>
          </div>
          {!isEditing ? (
            <button
              type="button"
              className={styles.quietButton}
              onClick={() => {
                setStatusMessage(null);
                setIsEditing(true);
              }}
            >
              Edit
            </button>
          ) : (
            <div className={styles.accountActions}>
              <button type="button" onClick={handleCancel}>
                Cancel
              </button>
              <button
                className={styles.accountSave}
                type="submit"
                disabled={isSaving || !email.trim()}
              >
                {isSaving ? "Saving..." : "Save"}
              </button>
            </div>
          )}
        </div>

        <label className={styles.accountField}>
          <span>Email</span>
          <input
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            disabled={!isEditing || isSaving}
            autoComplete="email"
          />
        </label>
        <label className={styles.accountField}>
          <span>First Name</span>
          <input
            type="text"
            value={firstName}
            onChange={(event) => setFirstName(event.target.value)}
            disabled={!isEditing || isSaving}
            autoComplete="given-name"
          />
        </label>
        <label className={styles.accountField}>
          <span>Last Name</span>
          <input
            type="text"
            value={lastName}
            onChange={(event) => setLastName(event.target.value)}
            disabled={!isEditing || isSaving}
            autoComplete="family-name"
          />
        </label>

        {statusMessage && (
          <p className={styles.accountStatus}>{statusMessage}</p>
        )}
      </form>
    </main>
  );
};
